import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShieldCheck, ShieldX, Search } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function VerifyCertificate() {
  const { certNo } = useParams();
  const navigate = useNavigate();
  const [q, setQ] = useState(certNo || "");
  const [state, setState] = useState({ loading: !!certNo, cert: null, error: "" });

  useEffect(() => {
    setQ(certNo || "");
    if (!certNo) { setState({ loading: false, cert: null, error: "" }); return; }
    setState({ loading: true, cert: null, error: "" });
    api.get(`/certificates/verify/${certNo}`)
      .then(({ data }) => setState({ loading: false, cert: data, error: "" }))
      .catch(() => setState({ loading: false, cert: null, error: "No certificate found with this number." }));
  }, [certNo]);

  const { cert, error, loading } = state;
  return (
    <div className="max-w-xl mx-auto px-6 py-16" data-testid="verify-certificate-page">
      <h1 className="font-heading text-3xl font-bold text-navy">Verify a Certificate</h1>
      <p className="text-muted-foreground mt-1 mb-6">Enter the certificate number printed on a VIRIKS certificate.</p>
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (q.trim()) navigate(`/verify/${q.trim().toUpperCase()}`); }}>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="VRK-2026-XXXXXXXX" data-testid="verify-input" />
        <Button type="submit" className="viriks-navy text-white" data-testid="verify-submit"><Search size={15} className="mr-1" /> Verify</Button>
      </form>
      {loading && <p className="mt-6 text-sm text-muted-foreground">Checking...</p>}
      {cert && (
        <div className="mt-6 border border-emerald-200 bg-emerald-50 rounded-xl p-6" data-testid="verify-valid">
          <div className="flex items-center gap-2 text-emerald-700 font-semibold"><ShieldCheck size={20} /> Valid certificate</div>
          <dl className="mt-4 grid grid-cols-[120px_1fr] gap-y-2 text-sm">
            <dt className="text-muted-foreground">Awarded to</dt><dd className="font-semibold text-navy">{cert.user_name}</dd>
            <dt className="text-muted-foreground">Course</dt><dd className="font-semibold text-navy">{cert.course_title}</dd>
            <dt className="text-muted-foreground">Issued on</dt><dd>{new Date(cert.issued_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</dd>
            <dt className="text-muted-foreground">Number</dt><dd className="font-mono">{cert.cert_no}</dd>
          </dl>
        </div>
      )}
      {error && <div className="mt-6 border border-crimson/20 bg-crimson/5 rounded-xl p-6 text-crimson flex items-center gap-2" data-testid="verify-invalid"><ShieldX size={20} /> {error}</div>}
    </div>
  );
}
